import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'usb-daily-prices',
  templateUrl: './daily-prices.component.html',
  styleUrls: ['./daily-prices.component.scss']
})
export class DailyPricesComponent implements OnInit, AfterViewInit {
  @Input() dailyPrices: any[] = [];
  @Input() currencies: any[] = [];
  @Input() currencyAgency: any;
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;

  visibleItems = 5;
  itemWidth = 166;
  currentIndex = 0;
  maxIndex = 0;

  ngOnInit(): void {
    this.updateVisibleItems();
    window.addEventListener('resize', () => this.updateVisibleItems());
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', () => this.updateVisibleItems());
  }

  updateVisibleItems(): void {
    const width = window.innerWidth;
    if (width >= 1200) {
      this.visibleItems = 5;
    } else if (width >= 992) {
      this.visibleItems = 4;
    } else if (width >= 768) {
      this.visibleItems = 3;
    } else {
      this.visibleItems = 2;
    }
    this.calculateMaxIndex();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.calculateMaxIndex();
    }, 100);
  }

  calculateMaxIndex(): void {
    const totalItems = this.dailyPrices.length;
    this.maxIndex = Math.max(0, Math.ceil(totalItems - this.visibleItems));
  }

  scrollLeft(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      const scrollPosition = this.currentIndex * this.itemWidth;
      this.scrollToPosition(scrollPosition);
    }
  }

  scrollRight(): void {
    if (this.currentIndex < this.maxIndex) {
      this.currentIndex++;
      const scrollPosition = this.currentIndex * this.itemWidth;
      this.scrollToPosition(scrollPosition);
    }
  }

  scrollToPosition(position: number): void {
    if (this.scrollContainer && this.scrollContainer.nativeElement) {
      this.scrollContainer.nativeElement.scrollTo({
        left: position,
        behavior: 'smooth'
      });
    }
  }
}
